module.exports = __webpack_public_path__ + "web/img/AI通过.59f8d388.png";